import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("companyUrl")
  ? JSON.parse(localStorage.getItem("companyUrl"))
  : {
      companyUrl: "",
    };
console.log("KKKKKKKKKKKKK<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
const companyUrlSlice = createSlice({
  name: "companyUrl",
  initialState,
  reducers: {
    companyUrlSuccess: (state, action) => {
      console.log(action.payload);
      state.companyUrl = action.payload.companyUrl;
      localStorage.setItem("companyUrl", JSON.stringify(action.payload));
    },
    // companyUrlSuccess: (state, action) => {
    //   state.companyUrl = null;

    //   // localStorage.removeItem("versions");
    // },
  },
});

export const { companyUrlSuccess } = companyUrlSlice.actions;

export const selectcompanyUrl = (state) => state.companyUrl;

export default companyUrlSlice.reducer;
